import { stagePointError } from '.'
import { AdjacentStagePointRule } from '../../../../../store/StageFile'

export const sequenceIdIsValid: AdjacentStagePointRule = (currentPoint, nextPoint) => {
    // In column A, each line should be numbered sequentially with no gaps.
    if (nextPoint.order != currentPoint.order + 1) {
        return stagePointError(nextPoint, `Order must increment by 1 each line - ${nextPoint.order} is not 1 more than ${currentPoint.order}`)
    }
}